import React, { useEffect, useRef, useState, useCallback } from "react";
import { connect } from "react-redux";
import { includes, isEmpty, size, filter, debounce, map } from "lodash";
import Emitter from "../../utils/Emitter";
import { getCategories, getCountryList } from "../../actions/defaultDataAction";
import { default as ReactSelect, components } from "react-select";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { showLoading, hideLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";
import ToolipsCustom from "../ToolipsCustom";
import { WithContext as ReactTags } from "react-tag-input";
import { getInqSuggetions,getOtherCategorySupplier } from "@/actions/inquiryAction";
import DropDown from "../DropDown";

const INQ_TYPES = [
    { label: "Register", value: "register" },
    { label: "Raw Data", value: "raw-data" },
];

const ViewSupplierFilter = (props) => {

    const current_inq_id = props.inqID ?? '';

    const { user } = useAuth();
    const { admin } = defaultValues;

    const [countryList, setCountryList] = useState([]);
    const [searchedTextbox, setSearchedTextbox] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const [selected_country, setSelectedCountry] = useState([]);

    const [supplierList, setSupplierList] = useState([]);
    const [selected_supplier, setSelectedSupplier] = useState([]);

    const [tags, setTags] = useState([]);
    const [suggestions, setSuggetions] = useState([]);

    const [searchedTxt, setSearchedTxt] = useState(null);
    const [loading, setLoading] = useState(false);

    const [findByInqTypeVal, setInqTypeVal] = useState(INQ_TYPES[0]);
    const typeRef = useRef(INQ_TYPES[0]);

    const requestIdRef = useRef(0);

      const setInqType = (val) => {
        typeRef.current = val;
        setInqTypeVal(val);
    };

    const [supplierLoading, setSupplierLoading] = useState(false);
    const searchTimer = useRef(null);
    const requestId = useRef(0);
    const [is_other,set_is_other] = useState("");

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                display: "flex",
                alignItems: "center"
            }}
            className={
                isSelected
                    ? "div-item-selected"
                    : "div-item-unselected"
            }
        >
            {isSelected && (
                <div className="item-selected">
                    <label style={{ marginLeft: "8px" }}>
                        {label}
                    </label>
                </div>
            )}

            {!isSelected && (
                <div className="item-selected2">
                    <label style={{ marginLeft: "8px" }}>
                        {label}
                    </label>
                </div>
            )}
        </div>
    );

    const customStyles = {
        control: (provided) => ({
            ...provided
        }),

        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#4c9bdb"
        }),

        multiValueLabel: (provided) => ({
            ...provided,
            color: "#fff",
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: "#df0024",

            ":hover": {
                backgroundColor: "#df0024"
            }
        })
    };


    const MoreSelectedBadge = ({ items }) => {

        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99
        };

        const title = items.join(", ");
        const length = items.length;

        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div
                style={style}
                title={title}
            >
                {label}
            </div>
        );
    };


    const MultiValue = ({ index, getValue, ...props }) => {

        const maxToShow = 2;

        const overflow = getValue()
            .slice(maxToShow)
            .map((x) => x.label);

        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <MoreSelectedBadge items={overflow} />
        ) : null;
    };


    const filterMembers = (e, current_tags = [],overrides = {}) => {

         const typeVal = overrides.typeVal ?? typeRef.current;
         const tagList =
            overrides.tags !== undefined
                ? overrides.tags
                : Array.isArray(current_tags)
                    ? current_tags
                    : tags;
        const ids = tagList.map((c) => c.id);
        const dataType = typeVal?.value ?? "register";

        const supplierSource =
        overrides.selected_supplier !== undefined
            ? overrides.selected_supplier
            : selected_supplier;

    const other_cat_supplier =
        selectedCategory?.label === "Other"
            ? (supplierSource || []).map((s) => String(s.value))
            : [];

        const filterObj = {
            filter_country: selected_country.map(
                (c) => c.value
            ),

            

            filterMemberId: ids || [],

            other_cat_supplier:other_cat_supplier,

            filter_type:
                selectedCategory?.value ?? "",

             filter_data_type: dataType,

            filter_val:
                searchedTextbox ?? "",

            table_search: "",

            columnName: "id",

            sortDirection:
                admin.SORT_DIRECTION,

            limit:
                admin.LIMIT,

            offset:
                admin.OFFSET
        };

        Emitter.emit(
            "FILTER_SUPPLIER_MEMBERS",
            filterObj
        );
    };

    /*
    |--------------------------------------------------------------------------
    | Clear Local Filter State (values AND state)
    |--------------------------------------------------------------------------
    |
    | Clears every piece of local UI state that belongs to this filter panel:
    | the country/category dropdown selections, the free-text search box,
    | the selected tags, the tag suggestions, and any in-flight search text.
    |
    | It ALSO clears the ReactTags component's own internal (uncontrolled)
    | input value and the plain "search_input" text node's DOM value, since
    | neither of those is driven by our React state and a `setTags([])`
    | alone will not empty the visible textbox.
    |
    | Shared by:
    |  - the local Reset button (resetFilter, below)
    |  - the "RESET_SUPPLIER_FILTER" event fired by the parent (e.g. after a
    |    successful bulk assign), so the filter panel reacts to it too.
    */
    const clearLocalFilterState = () => {

        // Bump the request id first so any suggestion/search request that
        // resolves after this point is ignored as stale.
        requestIdRef.current++;

        setSelectedCategory("");
        setSearchedTextbox("");
        setSelectedCountry([]);

        setSelectedSupplier([]);
        setSupplierList([]);
        setSupplierLoading(false);
        set_is_other("");
        clearTimeout(searchTimer.current);
        requestId.current++;

        setTags([]);
        setSuggetions([]);
        setSearchedTxt(null);
        setLoading(false);

        

        // Clear the ReactTags library's own internal text-input state.
        // const clearAllButton =
        //     document.getElementsByClassName(
        //         "ReactTags__clearAll"
        //     );

        // if (clearAllButton.length > 0) {

        //     clearAllButton[0].click();

        // }
        

        // Belt-and-braces: also clear the raw input value directly, in
        // case the library's clear-all button isn't present/rendered.
        const searchInput =
            document.getElementsByClassName(
                "search_input"
            )[0];

        if (searchInput) {
            searchInput.value = "";
        }
    };

    /*
    |--------------------------------------------------------------------------
    | Reset Filter
    |--------------------------------------------------------------------------
    |
    | Fully resets BOTH the visible values (dropdowns, tags, search box)
    | and the state that drives the table (filter object sent to the
    | parent), then triggers a fresh fetch with the cleared filter.
    */
    const resetFilter = () => {

        // 1. Clear this panel's own values/state immediately so the UI
        //    reflects the reset without waiting on the event round-trip.
        clearLocalFilterState();
        
        typeRef.current = INQ_TYPES[0];   
        setInqTypeVal(INQ_TYPES[0]);


        // 2. Build a fully-cleared filter object (no stale offset/limit,
        //    no leftover excludeMemberId from a previous delete/assign).
        const filterObj = {

            filter_country: [],

            filterMemberId: [],

            other_cat_supplier:[],

            excludeMemberId: [],

            filter_type: "",

            filter_data_type: "register",

            filter_val: "",

            table_search: "",

            sortDirection:
                admin.SORT_DIRECTION,

            columnName: "id",

            limit:
                Number(admin.LIMIT || 10),

            offset:
                Number(admin.OFFSET || 0)
        };

        props.showLoading();

        // 3. Tell any other listeners (this panel included, and the
        //    parent ViewSupplier) to reset their own local state too.
        Emitter.emit(
            "RESET_SUPPLIER_FILTER"
        );

        // 4. Ask the parent to refetch using the cleared filter.
        Emitter.emit(
            "FILTER_SUPPLIER_MEMBERS",
            filterObj
        );

        props.hideLoading();
    };

    const handleCategoryChange = (val) => {
        console.log("=--------=========",val);
        setSelectedCategory(val);
         if (val?.label === "Other") {
        set_is_other("Other");
    } else {
        // another category selected, or category cleared (val === null)
        set_is_other("");
        setSupplierList([]);
        setSelectedSupplier([]);      // use your own setter name for selected_supplier
        setSupplierLoading(false);
        clearTimeout(searchTimer.current);
    }
    };

    const handleSupplierChange = (val) => {
        console.log("handleSupplierChange ----",val);
        setSelectedSupplier(val);
    };

    useEffect(() => {
        const fetchDictionaries = async () => {
            try {
                const catRes = await props.getCategories();
                if (!isEmpty(catRes)) {
                    setCategoryList(map(catRes, (v) => ({ label: v.category_name, value: v.id })));
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchDictionaries();
    }, []);


   



    const handleCountryChange = (val) => {
        setSelectedCountry(val || []);
    };

    const normalizeApiResponse = (response) => {

        if (Array.isArray(response)) {
            return response;
        }

        if (Array.isArray(response?.data)) {
            return response.data;
        }

        if (Array.isArray(response?.data?.data)) {
            return response.data.data;
        }

        return [];
    };

    const mapResponseToSuggestions = (data) => {
        return (data || []).filter((v) => {
            if (!v) {
                return false;
            }
            if (v.id === undefined || v.id === null) {
                return false;
            }
            const companyName = String(v.company_name ?? "").trim();
            const memberNumber = String(v.member_unique_number ?? "").trim();
            const email = String(v.email ?? "").trim();
            return (companyName !== "" || memberNumber !== "" || email !== "");
        }).map((v) => {
            const companyName = String(v.company_name ?? "").trim();
            const memberNumber = String(v.member_unique_number ?? "").trim();
            const email = String(v.email ?? "").trim();
            let label = "";
            if (memberNumber) {
                label = memberNumber;
            } else if (email) {
                label = email;
            } else {
                label = companyName;
            }
            let text = "";
            if (companyName && memberNumber) {
                text = `${companyName} (${memberNumber})`;
            } else if (companyName) {
                text = companyName;
            } else if (memberNumber) {
                text = memberNumber;
            } else {
                text = email;
            }

            return {
                id: String(v.id),
                text: text,
                email: email,
                value: memberNumber || email || companyName,
                label: label
            };
        });
    };
    const callSuggestionsApi = (searchVal) =>
        props.getSupplierInqSuggetions(
            searchVal,
            current_inq_id,
            typeRef.current?.value ?? "register"
        );

    const fetchFilterSelection = async () => {

        try {

            const result =
                await Promise.allSettled([
                    props.getCountryList(),
                    // props.getSupplierInqSuggetions("", current_inq_id,findByInqTypeVal?.value)
                    callSuggestionsApi("")
                ]);

            result.forEach((res, indx) => {

                let dataList = [];
                let data = [];

                if (
                    res.status === "fulfilled"
                ) {

                    if (includes([0], indx)) {

                        data = res.value;

                    } else if (
                        includes([1], indx)
                    ) {

                        data =
                            normalizeApiResponse(
                                res.value
                            );
                    }

                    if (indx === 0) {

                        dataList =
                            data.map((v) => ({
                                label: v.name,
                                value: v.id
                            }));

                        setCountryList(
                            dataList
                        );
                    }

                    if (indx === 1) {

                        const mapped =
                            mapResponseToSuggestions(
                                data
                            );

                        setSuggetions(
                            mapped
                        );
                    }

                } else {
                    console.log(
                        "Something Went Wrong",
                        indx,
                        res.reason
                    );
                }
            });

        } catch (error) {

            console.log("fetchFilterSelection error:", error);
        }
    };


    const findMatchingSuggestion = (
        val,
        suggestionList
    ) => {

        if (
            isEmpty(val) ||
            isEmpty(suggestionList)
        ) {
            return null;
        }

        const needle =
            String(val)
                .trim()
                .toLowerCase();

        return (
            suggestionList.find((s) => {

                return (

                    String(
                        s.value ?? ""
                    )
                        .toLowerCase() ===
                    needle

                    ||

                    String(
                        s.email ?? ""
                    )
                        .toLowerCase() ===
                    needle

                    ||

                    String(
                        s.text ?? ""
                    )
                        .toLowerCase()
                        .includes(
                            needle
                        )
                );

            }) || null
        );
    };

    const isDuplicateTag = (
        candidate,
        existingTags
    ) => {

        return existingTags.some((t) => {

            return (

                (
                    candidate.id &&
                    String(t.id) ===
                    String(candidate.id)
                )

                ||

                (
                    candidate.value &&
                    String(t.value)
                        .toLowerCase() ===
                    String(candidate.value)
                        .toLowerCase()
                )

                ||

                (
                    candidate.email &&
                    String(t.email)
                        .toLowerCase() ===
                    String(candidate.email)
                        .toLowerCase()
                )
            );
        });
    };


    const extractAllTermsFromText = (text) => {

        const terms = String(text)

            .split(/[,\n]+/)

            .map((t) =>
                t.trim()
            )

            .filter(
                (t) => !isEmpty(t)
            );


        const uniqueTerms = [];

        const seen = new Set();

        terms.forEach((term) => {

            const key =
                term.toLowerCase();

            if (!seen.has(key)) {

                seen.add(key);

                uniqueTerms.push(term);
            }
        });

        return uniqueTerms;
    };


    const isBulkPaste = (text) => {

        const terms =
            extractAllTermsFromText(
                text
            );

        return (
            String(text).includes("\n") ||
            terms.length > 1
        );
    };

    // Filter OTS ID find pattern
    const CODE_PATTERN =
        /\b[A-Z]{2,6}\d{4,}\b/;

    const resolveBulkTermsAndAddTags = async (terms) => {
        if (!terms || terms.length === 0) {
            return [];
        }

        requestIdRef.current++;
        setLoading(true);

        try {
            const joinedTerms = terms.join(",");

            const rawResponse =
                await props.getSupplierInqSuggetions(
                    joinedTerms,
                    current_inq_id,findByInqTypeVal?.value
                );

            const apiData = normalizeApiResponse(rawResponse);

            const resolved =
                mapResponseToSuggestions(apiData);

            if (!isEmpty(resolved)) {
                setTags((prevTags) => {
                    const merged = [...prevTags];

                    resolved.forEach((item) => {
                        if (!isDuplicateTag(item, merged)) {
                            merged.push(item);
                        }
                    });

                    return merged;
                });
            }

            return resolved;

        } catch (error) {
            console.error("Bulk suggestion error:", error);
            return [];

        } finally {
            setLoading(false);
            setSearchedTxt(null);
        }
    };

    const handlePasteCapture = async (e, indx) => {
        const pastedText = e.clipboardData?.getData("text");

        if (!pastedText || !pastedText.trim()) {
            return;
        }

        /* if (!isBulkPaste(pastedText)) {
            return;
        } */

        e.preventDefault();
        e.stopPropagation();

        try {
            // 1. Extract pasted values
            const terms = extractAllTermsFromText(pastedText);
            if (terms.length === 0) {
                return;
            }

            // 2. Resolve pasted values through API
            const resolvedTags = await resolveBulkTermsAndAddTags(terms);

            // 3. Remove the old tag
            const newTags = tags.filter((_, idx) => idx !== indx);

            // 4. Merge old remaining tags + newly resolved tags
            const finalTags = [...newTags];

            resolvedTags.forEach((item) => {
                if (!isDuplicateTag(item, finalTags)) {
                    finalTags.push(item);
                }
            });

            // 5. Update React state
            setTags(finalTags);

            // 6. Filter immediately
            // filterMembers("", finalTags);
            props.showLoading();
            setTimeout(() => {
                props.hideLoading();
                filterMembers('',  finalTags);
            }, 2000);

        } catch (error) {
            console.error("handlePasteCapture error:", error);
        }
    };


    const getSuggetions = async (searchVal) => {
        const thisRequestId = ++requestIdRef.current;
        setLoading(true);
        try {
            const rawResponse = await props.getSupplierInqSuggetions(searchVal, current_inq_id,findByInqTypeVal?.value);
            if (thisRequestId !== requestIdRef.current) {
                return;
            }

            const mapped = mapResponseToSuggestions(normalizeApiResponse(rawResponse));
            setSuggetions(!isEmpty(mapped) ? mapped : []);
        } catch (err) {
            console.error("Suggestion API error:", err);
            if (thisRequestId === requestIdRef.current) {
                setSuggetions([]);
            }
        } finally {
            if (thisRequestId === requestIdRef.current) {
                setLoading(false);
            }
        }
    };


    const debouncedGetSuggetions = useRef(debounce((val) => getSuggetions(val), 300)).current;

    const handleInputChange = (tag) => {
        if (isEmpty(tag)) {
            setSearchedTxt(tag);
            requestIdRef.current++;
            setSuggetions([]);
            return;
        }
        if (String(tag).includes("\n") || isBulkPaste(tag)) {
            return;
        }
        setSearchedTxt(tag);
        if (size(tag) > 2) {
            debouncedGetSuggetions(tag);
        } else {
            requestIdRef.current++;
            setSuggetions([]);
        }
    };


    const findAllMatchingSuggestions = (
        val,
        suggestionList
    ) => {

        if (
            isEmpty(val) ||
            isEmpty(suggestionList)
        ) {
            return [];
        }

        const needle =
            String(val)
                .trim()
                .toLowerCase();

        return suggestionList.filter(
            (s) => {

                const value =
                    String(
                        s.value ?? ""
                    )
                        .toLowerCase();

                const email =
                    String(
                        s.email ?? ""
                    )
                        .toLowerCase();

                const text =
                    String(
                        s.text ?? ""
                    )
                        .toLowerCase();

                const label =
                    String(
                        s.label ?? ""
                    )
                        .toLowerCase();

                return (
                    value === needle ||
                    email === needle ||
                    label === needle ||
                    text.includes(needle)
                );
            }
        );
    };


    const addSingleTag = (suggestion) => {
        if (!suggestion) {
            return;
        }
        let updatedTags = tags; // fallback in case it's a duplicate (no-op)
        setTags((prevTags) => {
            if (isDuplicateTag(suggestion, prevTags)) {
                updatedTags = prevTags;
                return prevTags;
            }
            updatedTags = [...prevTags, suggestion];
            return updatedTags;
        });
        setSearchedTxt(null);
        props.showLoading();
        setTimeout(() => {
            props.hideLoading();
            filterMembers('', updatedTags);
        }, 2000);
    };


    const handleTagChange = async (tagVal) => {
        const rawText = tagVal.text || tagVal.value || tagVal.label || "";
        if (isBulkPaste(rawText)) {
            const terms = extractAllTermsFromText(rawText);
            await resolveBulkTermsAndAddTags(terms);
            return;
        }
        const exactById = suggestions.find(
            (s) => String(s.id) === String(tagVal.id));
        if (exactById) {
            addSingleTag(exactById);
            return;
        }
        const candidates = findAllMatchingSuggestions(rawText, suggestions);
        if (candidates.length === 1) {
            addSingleTag(candidates[0]);
            return;
        }
        if (candidates.length > 1) {
            setSearchedTxt(rawText);
            return;
        }
        const codeMatch = String(rawText).match(CODE_PATTERN);
        if (codeMatch) {
            await resolveBulkTermsAndAddTags(
                [codeMatch[0]]);
            return;
        }
        if (rawText.length > 2) {
            try {
                setLoading(true);
                const rawResponse = await props.getSupplierInqSuggetions(rawText, current_inq_id,findByInqTypeVal?.value);
                const mapped = mapResponseToSuggestions(normalizeApiResponse(rawResponse));
                if (mapped.length === 1) {
                    addSingleTag(mapped[0]);
                } else {
                    setSuggetions(mapped);
                    setSearchedTxt(rawText);
                }
            } catch (error) {
                console.error("Manual search error:", error);
            } finally {
                setLoading(false);
            }
            return;
        }
        setSearchedTxt(null);
    };


    const handleDelete = (i) => {

        setTags((prevTags) => {
            const removed = prevTags[i];
            if (removed?.id !== undefined && removed?.id !== null) {
                Emitter.emit("REMOVE_MEMBER_ID_TAG", removed.id);
            }
            return filter(
                prevTags,
                (_, idx) =>
                    idx !== i
            );
        });
    };


    // Removes a single tag from the "selected-custom-tags" chip list and
    // immediately re-runs the filter with the updated tag set. Also emits
    // REMOVE_MEMBER_ID_TAG so the parent stays in sync, matching handleDelete.
   const handleRemoveTag = (e, indx) => {
        e.preventDefault();
        const removed = tags[indx];
        const oldTags = [...tags];
        let newTags = oldTags.filter((_, idx) => idx !== indx);
        setTags(newTags);
        /* if (removed?.id != null) {
            Emitter.emit("REMOVE_MEMBER_ID_TAG", removed.id);
        } */
        props.showLoading();
        setTimeout(() => {
            props.hideLoading();
            filterMembers('', newTags);
        }, 2000);
        /* setTags((prevTags) => {
            const removed = prevTags[indx];
            if (removed?.id !== undefined && removed?.id !== null) {
                Emitter.emit("REMOVE_MEMBER_ID_TAG", removed.id);
            }
            return filter(prevTags, (_, idx) => idx !== indx);
        }); */
    };


    const handleRemoveAllTags = () => {

        setTags((prevTags) => {
            const ids = prevTags
                .map((t) => t.id)
                .filter((tid) => tid !== undefined && tid !== null);

            if (ids.length > 0) {
                Emitter.emit("REMOVE_MEMBER_ID_TAG", ids);
            }

            return [];
        });

        setSuggetions([]);

        setSearchedTxt(null);

        requestIdRef.current++;
    };


    useEffect(() => {

        const handleRemoveTagById = (id) => {

            if (id === undefined || id === null) {
                return;
            }

            setTags((prevTags) =>
                prevTags.filter(
                    (t) => String(t.id) !== String(id)
                )
            );
        };

        Emitter.on("REMOVE_SUPPLIER_TAG", handleRemoveTagById);

        return () => {
            Emitter.off("REMOVE_SUPPLIER_TAG", handleRemoveTagById);
        };

    }, []);

    // Listen for a parent-triggered reset (e.g. after a successful bulk
    // assign in ViewSupplier) and actually clear the tags/dropdowns here.
    // Also fires when this panel's own Reset button is clicked, but
    // clearLocalFilterState() is idempotent so that's harmless.
    useEffect(() => {

        Emitter.on("RESET_SUPPLIER_FILTER", clearLocalFilterState);

        return () => {
            Emitter.off("RESET_SUPPLIER_FILTER", clearLocalFilterState);
        };

    }, []);


    useEffect(() => {

        fetchFilterSelection();

    }, []);



    const clearSearchInputDom = () => {
        const searchInput = document.getElementsByClassName("search_input")[0];
        if (searchInput) {
            searchInput.value = "";
        }
    };

  const handleFindTypeChange = (val) => {
     if (!val || val.value === typeRef.current?.value) {
            return;
        }

        typeRef.current = val;
        setInqTypeVal(val);

        requestIdRef.current++;

        setTags([]);
        setSuggetions([]);
        setSearchedTxt(null);
        setLoading(false);
        clearSearchInputDom();

        // reload default suggestions for the new type
        getSuggetions("");

        // refetch the table for the new type, with no tags
        filterMembers('', [], { typeVal: val, tags: [] });
  };

  
  const fetchSupplier = async (search = "") => {
    console.log("fetchSupplier search =", search);   // debug: must print what you typed

    const currentRequest = ++requestId.current;
    setSupplierLoading(true);
    try {
        const res = await props.getOtherCategorySupplier(search);
        if (currentRequest !== requestId.current) return;

       setSupplierList(
            map(res?.data || [], (v) => ({
                label: `${v.company_name} (${v.member_unique_number})`,
                value: v.id,
                email: v.email,
                uniqu: v.member_unique_number,
            }))
        );
    } catch (err) {
        console.error(err);
    } finally {
        if (currentRequest === requestId.current) setSupplierLoading(false);
    }
};

useEffect(() => {
    if (is_other === "Other") {
        fetchSupplier("");
    }
}, [is_other]);

useEffect(() => () => clearTimeout(searchTimer.current), []);

const handleSupplierInputChange = (inputValue, { action }) => {
    console.log("input action =", action, "value =", inputValue);   // debug

    if (action === "input-change") {
        clearTimeout(searchTimer.current);
        searchTimer.current = setTimeout(() => {
            fetchSupplier(inputValue);
        }, 400);
    } else if (action === "menu-close") {
        clearTimeout(searchTimer.current);
        fetchSupplier("");
    }
    return inputValue;
};

    return (
        <div className="bg-white shadow rounded mt-4 mb-4">

             <div className="buyer-suplier-search-section member-filter all-admin-inquiry">

                <div className="buyer-suplier-section-child all">
                     <DropDown
                        placeholder="Select.."
                        options={INQ_TYPES}
                        value={findByInqTypeVal}
                        onChange={handleFindTypeChange}
                        menuPlacement="bottom"
                    />
          </div>

                <div className = "col-xl-2 col-md-6" >
                    <ReactSelect
                        options = {countryList}
                        isMulti
                        closeMenuOnSelect = {false}
                        hideSelectedOptions = {false}
                        components = {{
                            Option: CustomOption,
                            IndicatorSeparator: () => null,
                            MultiValue
                        }}
                        onChange = {handleCountryChange}
                        value = {selected_country}
                        styles = {customStyles}
                        placeholder = "Select Country"
                        className = "member-filter-container"
                        classNamePrefix = "member-filter-select"
                        noOptionsMessage = {() => "No Country Found"}
                        id = "country_dropdown" /> 
                </div>


                <div className ="col-xl-2 col-md-6"> 
                    <ReactSelect
                        options={categoryList}
                        isClearable
                        closeMenuOnSelect ={true}
                        onChange ={handleCategoryChange}
                        value = {selectedCategory}
                        styles = {customStyles}
                        placeholder = "Select Category"
                        className = "member-filter-container"
                        classNamePrefix = "member-filter-select"
                        noOptionsMessage ={() => "No Category Found" }
                        id="category_id"
                        name = "category_id" 
                    />
                </div>
            {is_other === "Other" && 
                <div className="col-xl-2 col-md-6">
                    <ReactSelect
                        options={supplierList}
                        isMulti
                        isLoading={supplierLoading}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        filterOption={() => true}      // server already filtered the results
                        onInputChange={handleSupplierInputChange}
                        components={{
                            Option: CustomOption,
                            IndicatorSeparator: () => null,
                            MultiValue,
                        }}
                        onChange={handleSupplierChange}
                        value={selected_supplier}
                        styles={customStyles}
                        placeholder="Select Other Category"
                        className="member-filter-container"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Data Found"}
                        loadingMessage={() => "Searching..."}
                        id="supplier_dropdown"
                        isDisabled={is_other !== "Other"}
                    />
                </div>
                }
                {/* =================================================
                    TAG SEARCH
                ================================================= */}

                <div className = "col-xl-4 col-lg-6 col-md-6" > 
                    <div onPasteCapture={handlePasteCapture}> 
                        <ReactTags
                            tags={tags}
                            name = "search_txt"
                            inputFieldPosition = "top"
                            suggestions={suggestions}
                            placeholder={loading ? "Searching..." : "Search Keywords"}
                            handleDelete = {handleDelete}
                            handleAddition = {handleTagChange}
                            handleInputChange = {handleInputChange}
                            editable = {false}
                            clearAll
                            onClearAll={handleRemoveAllTags}
                            allowAdditionFromPaste
                            classNames = {{ tagInputField: "form-control form-size w-100 search_input" }}
                            inputProps = {{ autoComplete: "off" }}
                            handleFilterSuggestions={(textInputValue, possibleSuggestions) => possibleSuggestions}
                        />
                    </div>
                </div>

                {/* =================================================
                    SEARCH / RESET
                ================================================= */}
                <div className="filter-search-btn col-xl-2 col-lg-12 d-flex align-items-center search">

                    <ButtonAdminpanel
                        type="button"
                        onClick={(e) => filterMembers(e, tags)}
                        className="btn-regi"
                    >
                        <i className="fa-solid fa-magnifying-glass text-white"></i>
                        {" "}Search

                    </ButtonAdminpanel>

                    <button
                        type="button"
                        className="btn filter-reset-btn mx-2"
                        onClick={
                            resetFilter
                        }
                    >

                        <svg
                            viewBox="0 0 21 21"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                        >

                            <g
                                id="SVGRepo_bgCarrier"
                                strokeWidth="0"
                            />

                            <g
                                id="SVGRepo_tracerCarrier"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />

                            <g
                                id="SVGRepo_iconCarrier"
                            >

                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#000000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    transform="matrix(0 1 1 0 2.5 2.5)"
                                >

                                    <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8" />

                                    <path
                                        d="m4 1v4h-4"
                                        transform="matrix(1 0 0 -1 0 6)"
                                    />

                                </g>

                            </g>

                        </svg>

                        {" "}Reset

                    </button>

                </div>

                {/* =================================================
                    SELECTED TAGS
                ================================================= */}

                <div className="row pt-2">

                    <div className="col-md-12 col-xl-12">

                        <div className="selected-custom-tags p-0">

                            {tags.map(
                                (val, indx) => {

                                    return (

                                        <div
                                            key={`tag_${indx}`}
                                            className="selected-custom-tags-child"
                                        >

                                            <ToolipsCustom
                                                className="selected-custom-tag-text hscode-tooltip"
                                                classNameChild="hscode-tooltip-msg member"
                                                title={
                                                    val.label
                                                }
                                                subtitle={`${val.text || ""} ${val.email || ""}`}
                                            />

                                            <div className="selected-custom-tag-button" onClick={(e) =>
                                                        handleRemoveTag(
                                                            e,
                                                            indx
                                                        )
                                                    }>

                                                <i
                                                    className="fa-solid fa-x mx-1"
                                                    key={`remove_${indx}`}
                                                    // onClick={(e) =>
                                                    //     handleRemoveTag(
                                                    //         e,
                                                    //         indx
                                                    //     )
                                                    // }

                                                />

                                            </div>

                                        </div>
                                    );
                                }
                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

// =============================================================
// Redux
// =============================================================

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
        getCategories: () => dispatch(getCategories()),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        getSupplierInqSuggetions: (searchTxt, current_inq_id,type) => dispatch(getInqSuggetions(searchTxt, current_inq_id,type)),
        getOtherCategorySupplier: (search) => dispatch(getOtherCategorySupplier(search)),
        
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    React.memo(
        ViewSupplierFilter
    )
);